import { Badge } from '@rentflowdev/ui'
import type { Property } from '@/types'
import { useTranslation } from 'react-i18next'

const STATUS_VARIANTS: Record<Property['status'], 'muted' | 'secondary' | 'default' | 'success' | 'warning'> = {
  DRAFT:    'muted',
  AVAILABLE:'success',
  RENTED:   'warning',
  ARCHIVED: 'default',
}

interface PropertyStatusBadgeProps {
  status: Property['status']
}

export function PropertyStatusBadge({ status }: PropertyStatusBadgeProps) {
  const { t } = useTranslation()

  return <Badge variant={STATUS_VARIANTS[status]}>{t(`properties.statuses.${status}`)}</Badge>
}
